import { Group } from '@components/layout';
import { Box, Stack } from '@mui/material';
import { useEffect } from 'react';
import { DatasetsDetails, DatasetsTable, useDatasets } from './datasets';

interface LibrariesDatasetsProps {
  workspaceId: string;
  datasetId?: string;
}

export const LibrariesDatasets = (params: LibrariesDatasetsProps) => {
  const { datasetId } = params;
  const { pagination, selectedDataset, setSelectedDataset } = useDatasets();
  useEffect(() => {
    if (selectedDataset) {
      return;
    }
    if (datasetId) {
      if (pagination.data) {
        const dataset = pagination.data.find((d) => d.datasetId === datasetId);
        if (!dataset) {
          void pagination.fetchMore();
        }
        setSelectedDataset(datasetId);
      }
    }
  }, [pagination, datasetId, selectedDataset, setSelectedDataset]);

  return (
    <Stack sx={{ height: '100%', overflow: 'hidden' }}>
      <Group height="100%" gap={10}>
        <Box flex={1}>
          <DatasetsTable />
        </Box>
        <Box width="35%">
          <DatasetsDetails {...params} />
        </Box>
      </Group>
    </Stack>
  );
};
